/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from 'react';
import clsx from 'clsx';
import SizedBox, { SizedBoxProps } from './SizedBox';

export interface FlexComponentProps extends SizedBoxProps {
  align?: 'start' | 'end' | 'center' | 'stretch' | 'baseline';
  className?: string;
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  justify?: 'start' | 'end' | 'center' | 'space-between' | 'space-evenly' | 'space-around';
  inline?: boolean;
  wrap?: boolean;
}

const Flex: FC<FlexComponentProps> = ({
  direction = 'row',
  align = 'start',
  justify = 'start',
  inline,
  wrap = false,
  children,
  className,
  ...rest
}) => {
  const cls = {
    'flex-row': direction === 'row',
    'flex-row-reverse': direction === 'row-reverse',
    'flex-column': direction === 'column',
    'flex-column-reverse': direction === 'column-reverse',
    'align-flex-start': align === 'start',
    'align-flex-end': align === 'end',
    'align-center': align === 'center',
    'align-stretch': align === 'stretch',
    'align-baseline': align === 'baseline',
    'justify-flex-start': justify === 'start',
    'justify-flex-end': justify === 'end',
    'justify-center': justify === 'center',
    'justify-space-between': justify === 'space-between',
    'justify-space-around': justify === 'space-around',
    'justify-space-evenly': justify === 'space-evenly',
    'flex-wrap': wrap,
  };

  return (
    <SizedBox
      {...rest}
      className={clsx(cls, className)}
      display={inline ? 'inline-flex' : 'flex'}
    >
      {children}
    </SizedBox>
  );
};

export default Flex;
